import { Injector } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { INgxPrimengForm } from 'ngx-primeng-form';

import { INgxManageLayoutDialogData, INgxManageLayoutActionButton } from '../models/ngx-manage-layout.model';
import { NgxUtility } from '../../core/public-api';
import { DialogFormBaseComponent } from '../../core/_base/dialog-form.base';
import * as _ from 'lodash';

export abstract class NgxManageLayoutDialogBaseComponent<TModel> extends DialogFormBaseComponent<INgxManageLayoutDialogData<TModel>, TModel>{
    // define form items
    formItems: INgxPrimengForm[] = [];

    // when action fire
    protected abstract handleOnAction(formValue: any, action: INgxManageLayoutActionButton): void;

    constructor(manageDialognjector: Injector) {
        super(manageDialognjector);
    }

    // load form
    protected loadForm(formBuilder: FormBuilder) {
        // make sure form shoule initialize
        const formResult = this.prepareForm(formBuilder, this.dialogData.layout.form.controls);
        // clone form
        this.cloneFormGroup(formResult.formGroup, this.form);
        // set form items
        this.formItems = formResult.forms;
        // process form data
        this.processData(this.form);
    }

    // process data
    private processData(formGroup: FormGroup) {
        const data = this.dialogData;
        if (data && data.model) {
            //pre action
            // clone
            const model = _.cloneDeep(data.model);
            // patach value
            this.patchValue(this.overrideSetFormDataPreAction(model), formGroup);
            // post action
            this.overrideSetFormDataPostAction();
        }
    }

    // handle when action performed
    handleAction(event: INgxManageLayoutActionButton) {
        switch (event.key) {
            case 'cancel': {
                this.closeDialog();
            } break;
            default: {
                this.handleOnAction(this.getActionFormValue(), event);
            } break;
        }
    }

    // get action form value
    private getActionFormValue(): any {
        // get form value
        const formValue = _.cloneDeep(this.form.value);
        // get dialog data
        const data = _.cloneDeep(this.dialogData);
        // null check
        if (data && data.model) {
            // set primary key
            // cross check that model has key or not
            if (NgxUtility.hasPropertyValue(data.model, this.dialogData.layout.setting.pk)) {
                formValue[this.dialogData.layout.setting.pk] = this.dialogData.model[this.dialogData.layout.setting.pk];
            }
        }
        return formValue;
    }

    protected overrideSetFormDataPreAction(model: TModel): TModel { return model; }

    protected overrideSetFormDataPostAction() { }

}